import { combineReducers } from "@reduxjs/toolkit";
import navigationSlice from "./navigationSlice";

export default combineReducers({
  navigation: navigationSlice,
});
